module.exports = __webpack_public_path__ + "static/media/ImagineInternet_NMD_2019.6da52d8f.pdf";